import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { ButtonStyled } from './ButtonExpand.styles';

export const ButtonExpand = ({ onClick, expand, ...rest }) => (
  <ButtonStyled onClick={onClick} {...rest}>
    <FontAwesomeIcon icon={expand ? faChevronDown : faChevronUp} />
  </ButtonStyled>
);

ButtonExpand.propTypes = {
  onClick: PropTypes.func,
  expand: PropTypes.bool,
};
